import type { Prototype } from "../prototype-types";

export const trungNguyenPrototypes: Prototype[] = [
  {
    id: "tn-cart-experience-improvement",
    name: "Cart Experience Improvement",
    path: "/tn/cart-experience-improvement",
    description:
      "Recreates the current retailer cart experience end to end — homepage, add to cart from the product popup, the multi-brand Carts page and per-brand cart, and checkout — as a baseline before iterating on the design.",
    owner: "Trung Nguyen",
    createdAt: "2026-10-08",
    lastUpdated: "2026-10-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tn-cart-experience-improvement.png",
    creationTool: "claude-code",
  },
  {
    id: "tn-highlight-messenger",
    name: "Highlight Messenger",
    path: "/tn/highlight-messenger",
    description:
      "Makes the messenger eye-catching for retailers across three surfaces: pulls 'Message brand' into the PDP viewport at the same visual weight as 'Shop all products', keeps the messenger FAB available on the homepage even before a retailer has any conversations, and gives the brand page a labelled messenger entry point instead of a bare chat glyph.",
    owner: "Trung Nguyen",
    createdAt: "2026-08-07",
    lastUpdated: "2026-08-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/22478f43121277ab3a4af17569dcc84a11ca9dc9be6003ba9e3a15238b4de970.png",
    creationTool: "claude-code",
  },
  {
    id: "tn-prominent-messenger-icon",
    name: "Prominent Messenger Icon",
    path: "/tn/prominent-messenger-icon",
    description:
      "Relocates the messenger access point from the floating bubble into a messenger icon in the top navigation bar, and removes the redundant Messages entry from the profile menu.",
    owner: "Trung Nguyen",
    createdAt: "2026-07-19",
    lastUpdated: "2026-07-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2df0be80e2e3a3fd9253bc8928757e76c393723089cc1ce75f565997ee5ee92d.png",
    creationTool: "claude-code",
  },
  {
    id: "tn-messenger-popup-chat-revamp",
    name: "Messenger Popup Chat Revamp",
    path: "/tn/messenger-popup-chat-revamp",
    description:
      "Replaces the blank 'Start a Conversation' modal on the brand page and PDP with a popup chat window that keeps prior message history in view, so retailers don't lose context with a brand.",
    owner: "Trung Nguyen",
    createdAt: "2026-07-21",
    lastUpdated: "2026-07-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6a8e001ddb5f15bccd61b0abd547483ce3b878cd5f785b375de3995477852631.png",
    creationTool: "claude-code",
  },
  {
    id: "tn-enabling-emoji-reaction-messenger",
    name: "Enabling Emoji Reaction Messenger",
    path: "/tn/enabling-emoji-reaction-messenger",
    description: "Recreates the current staging look of the messenger emoji picker and message reactions across the popup chat widget and full Messages page, as a baseline before iterating on the design.",
    owner: "Trung Nguyen",
    createdAt: "2026-09-22",
    lastUpdated: "2026-09-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tn-enabling-emoji-reaction-messenger.png",
    creationTool: "claude-code",
  }
];
